import { FC } from "react";
import styles from "../Alert.module.scss";
import { createModalHelpers } from "@stores/unified-modal.store";
import { useModal } from "@hooks/useModal";
import ModalContent from "../../Modal/ModalContent";
import Modal from "../../Modal";
import Icon from "../../Icon";
import cn from "classnames";

const WarningTransaction: FC = () => {
    const { warningTransaction, openModal, closeModal } = createModalHelpers();
    const [_, handleClose] = useModal(() => closeModal("warningTransaction"));

    return (
        <Modal
            isVisible={warningTransaction}
            setIsVisible={(isVisible) =>
                isVisible ? openModal("warningTransaction") : closeModal("warningTransaction")
            }
        >
            <ModalContent classNames={styles.content}>
                <div className={styles.header}>
                    <button className={styles.close} onClick={handleClose}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <div className={styles.iconHolder}>
                    <Icon type="Warning" />
                </div>
                <div className={styles.text}>
                    <h2 className={styles.headline}>High price impact</h2>
                    <p className={styles.description}>
                        This order will cause the price to move 3.45 from the current market price. Are you sure you
                        want to proceed
                    </p>
                    <div className={styles.buttons}>
                        <button onClick={handleClose} className={cn(styles.button, styles.cancel)}>
                            <span>Cancel</span>
                        </button>
                        <button className={styles.button}>
                            <span>Continue</span>
                            <img width={10} height={10} src="/images/swap/right.svg" alt="" />
                        </button>
                    </div>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default WarningTransaction;
